module.exports = __webpack_public_path__ + "static/img/003-3.498db872.png";